<template>
  <div class="wrapper">
    <div class="img" style="">
      <img
        src="@/assets/images/meeting.png"
        alt="点击进入会议"
        title="点击进入会议"
        width="400"
        @click="enterMeeting"
      />
      <div style="margin-top: 20px; font-size: 20px; text-align: center">
        点击开始进入会议
      </div>
      <div style="margin-top: 20px; font-size: 20px; text-align: center">
        【会议】{{ result.eventName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: {},
    };
  },

  created() {
    this.result = this.$route.params.result;
  },

  components: {},

  computed: {},

  methods: {
    enterMeeting() {
      console.log(123);
      location.href = this.result.ext02;
    },
  },
};
</script>
<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.img {
  margin-top: 200px;
  cursor: pointer;
}
</style>